import React from 'react'

import Icon, * as IconAnt from '@ant-design/icons'
import { Card } from 'antd'
import PropTypes from 'prop-types'

const TopicCard = ({ title = '', iconName = '', onClick }) => {
  return (
    <Card className="cardWrapper" bordered={false} onClick={onClick}>
      <div className="cardContent">
        <div className="cardIcon">
          <Icon component={IconAnt[iconName]} style={{ fontSize: 24, color: '#ff0000' }} />
        </div>
        <div>{title}</div>
      </div>
    </Card>
  )
}

TopicCard.propTypes = {
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default TopicCard
